import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-bell-lined",
  "use": "rt-base-bell-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-bell-lined\"><path d=\"M928 784h-70V450.9c0-44.7-8.8-88-26-128.8-16.7-39.4-40.5-74.8-70.9-105.2-30.4-30.4-65.8-54.2-105.2-70.9-35.7-15.1-73.2-23.7-111.9-25.6V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v24.4c-38.7 1.9-76.3 10.5-111.9 25.6-39.4 16.7-74.8 40.5-105.2 70.9-30.4 30.4-54.2 65.8-70.9 105.2-17.3 40.8-26 84.1-26 128.8V784H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h304c0 61.8 50.2 112 112 112s112-50.2 112-112h304c17.7 0 32-14.3 32-32s-14.3-32-32-32zM512 896c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM230 450.9c0-71.3 27.8-138.3 78.2-188.7S425.6 184 496.9 184h30.3c71.3 0 138.3 27.8 188.7 78.2S794 379.6 794 450.9V784H230V450.9z\" /><path d=\"M680 454c-17.7 0-32 14.3-32 32v176c0 17.7 14.3 32 32 32s32-14.3 32-32V486c0-17.7-14.3-32-32-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/bell-lined.svg
// module id = 1687
// module chunks = 137